<template>
    <div class="item-layout">
        <a-form :form="form" class="form-ui pop-common-form">
            <a-form-item
                class="form-item"
                v-bind="formItemLayout"
                :validate-status="form.type.validateStatus"
                :help="form.type.help"
                hasFeedback>
                <template slot="label">
                <span class="required">商家类型</span>
                </template>
                <a-select :value="form.type.alias"
                    @change="validateSelect"
                    class="select-ui" >
                    <a-select-option :value="item.type" v-for="(item,index) in buzzTypeList" :key="index">
                    {{item.name}}
                    </a-select-option>
                </a-select>
            </a-form-item>
            <a-form-item
                class="form-item"
                v-bind="formItemLayout"
                :validate-status="form.code.validateStatus"
                :help="form.code.help"
                hasFeedback>
                <template slot="label">
                <span class="required">商家编码</span>
                </template>
                <a-input
                placeholder="请输入商家编码"
                v-model="form.code.value"
                @change="validateHandler('code', $event)"
                />
            </a-form-item>
            <a-form-item
                class="form-item"
                v-bind="formItemLayout"
                :validate-status="form.password.validateStatus"
                :help="form.password.help"
                hasFeedback>
                <template slot="label">
                <span class="required">商家编码密码</span>
                </template>
                <a-input
                type="password"
                placeholder="请输入商家编码密码"
                v-model="form.password.value"
                @change="validateHandler('password', $event)"
                />
            </a-form-item>
            </a-form>
            <BtnList style="margin-left:-208px;" @handle="submit" text="提交"></BtnList>
    </div>
</template>
<script>
import queryString from 'query-string'
import {Input,Select,message} from 'ant-design-vue'
import {find} from 'lodash'

const {Option} = Select;
import {mapActions } from 'vuex'
import {$http,user,sessionStore,jump,buzzTypeList} from '@utils'
import {portalApi} from '@utils/api'
import BtnList from '../btnList'
export default {
    components:{AInput:Input,BtnList,ASelect:Select,ASelectOption:Option},
    data(){
        return {
            buzzTypeList,
            formItemLayout: {
                labelCol: {
                xs: { span: 4 },
                },
                wrapperCol: {
                xs: { span: 20 },
                },
            },
            form: {
                type: {
                    alias:'请选择',
                    value: '',
                    validateStatus: '',
                    help: ''
                },
                code: {
                    value: '',
                    validateStatus: '',
                    help: '样例：WX177719'
                },
                password: {
                    value: '',
                    validateStatus: '',
                    help: '采销人员提供的、与商家编码对应的密码'
                }
            }
        }
    },
    created(){
        this.subscribeFun = this.$store.subscribe((mutation, state) => {
            if(mutation.type == 'getUserInfo') {
                const userInfo = mutation.payload;
                if(userInfo.buzzType) {
                    const item = find(buzzTypeList,o => o.type == userInfo.buzzType);
                    if(item) {
                        this.form.type.alias = item.name;
                        this.form.type.value = item.type;
                    }
                } 
            }
        })
    },
    beforeDestroy(){
        this.subscribeFun();
    },
    methods:{
        ...mapActions(['getUserInfo']),
        /**
         * 校验逻辑
         * @param field {string} 表单域名
         * @param v {string} 值
         */
        validators (field, v) {
            const status = ['success', 'warning', 'error', 'validating'];
            const mapper = {
                type (field, v, status) {
                    if (!v || v === '') {
                        this.form[field].validateStatus = status[2];
                        this.form[field].help = '请选择一个商家类型'
                    }  else {
                        const item = this.buzzTypeList.find(item => v == item.type);
                        if(item) {
                            this.form[field].value = item.type;
                            this.form[field].alias = item.name;
                        }  
                        this.form[field].validateStatus = status[0];
                        this.form[field].help = ''
                    }
                },
                code (field, v, status) {
                    if (!v || v === '') {
                        this.form[field].validateStatus = status[2];
                        this.form[field].help = '商家编码不能为空'
                    } else if (v.length >= 10) {
                        this.form[field].validateStatus = status[2];
                        this.form[field].help = '请保持10个字符以内!'
                    } else {
                        this.form[field].validateStatus = status[0];
                        this.form[field].help = ''
                    }
                },
                password (field, v, status) {
                    if (!v || v === '') {
                        this.form[field].validateStatus = status[2];
                        this.form[field].help = '密码不能为空'
                    } else if (v.length >= 20) {
                        this.form[field].validateStatus = status[2];
                        this.form[field].help = '请保持20个字符以内!'
                    } else {
                        this.form[field].validateStatus = status[0];
                        this.form[field].help = ''
                    }
                }
            };
            // 检查有效field
            if (mapper[field]) {
                mapper[field].call(this, field, v, status)
            }
        },
        validateHandler (field, e) {
            const v = e.target.value;
            this.validators(field, v)
        },
        validateSelect(value, option){
            this.validators('type', value)
        },
        /**
         * 复写-校验表单
         * @param fields {undefined | string | Array} 校验域
         * @return {boolean}
         */
        validateFields (fields=undefined) {
        const { validators } = this;
        let result = true;
        if (fields) {
            // instanceof 会检视构造器，因此会存在 '' instanceof String === false 的情况
            if (typeof fields === 'string') {
            const { value } = this.form[fields];
            validators(fields, value);
            const { validateStatus } = this.form[fields];
            if (validateStatus && validateStatus !== 'success') {
                result = false
            }
            } else if (fields instanceof Array) {
            for (let field of fields) {
                const { value } = this.form[field];
                validators(field, value);
                const { validateStatus } = this.form[field];
                if (validateStatus && validateStatus !== 'success') {
                result = false
                }
            }
            }
        } else {
            // 循环表单key
            for (let k of Object.keys(this.form)) {
            const { value } = this.form[k];
            validators(k, value);
            const { validateStatus } = this.form[k];
            if (validateStatus && validateStatus !== 'success') {
                result = false
            }
            }
        }

        return result
        },
        async submit(){
            if(this.validateFields()){
                const {type,code,password} = this.form;
                const buzzType = type.value;
                const buzzCode = code.value;
                const buzzPass = password.value;
                const aid = user.id;
                const param = JSON.stringify({
                    aid,buzzType,buzzCode,buzzPass
                })
                const response = await $http.post(portalApi.bindAccount,queryString.stringify({param}),{
                                                headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                if(response && response.code == 1) {
                    this.getUserInfo();
                   jump.enterManage();
                    //jump.logoutRefer({name:'login'})
                } else if(response && response.msg){
                    message.error(response.msg);
                }     
            }
        }
    }
}
</script>
<style lang="scss">
.item-layout form.form-ui .form-item .has-feedback :not(.ant-input-group-addon) > .ant-select .ant-select-arrow {
    right: 11px;
}
    .item-layout {
        form.form-ui {
            .form-item {
                .select-ui {
                    .ant-select-selection {
                        border-radius: 2px;
                    }
                    .ant-select-selection--single {
                        height: 38px;
                    }
                    .ant-select-selection__rendered {
                        line-height: 36px;
                    }
                }
                
            }
        }
    }
</style>

<style lang="scss" scoped>
$primary_dark_color: #116CD0;
 .item-layout {
     .select-ui {
         width: 260px;
     }
     .form-ui {
        margin: 0 auto;
        margin-top: 48px;
        width: 700px;
        .form-item {
            .op-btn {
            width: 130px;
            height: 38px;
            & + .op-btn {
                margin-left: 20px;
            }
            }
            .tip {
            font-family: MicrosoftYaHei;
            font-size: 12px;
            color: #999999;
            letter-spacing: 0;
            .link {
                color: $primary_dark_color;
                &:hover {
                cursor: pointer;
                }
            }
            }
            input {
            width: 260px;
            }
        }
    }
    
 }
</style>


